import config from "../../config";
import CardHeader from "../../components/CardHeader.vue";
import TeacherCard from "components/TeacherCard";
import swiperTeacherList from './swiperTeacherList';
import { Empty } from "zhs-components";
export default {
  components: {
    TeacherCard,
    Empty,
    CardHeader,
    swiperTeacherList
  },
  props: {
    menu: Object
  },

  created() {
    this.getTeacherList();
  },

  data() {
    return {
      teacherList: [],
      dialogTeacherVisible: false,
      currentTeacher: {},
      abbr: config.abbr
    };
  },

  methods: {
    async getTeacherList() {
      const list = await this.$http.getHomeTeachers({
        num: this.menu.num,
        menu_id: this.menu.id
      });
      console.log("名师", list);
      this.teacherList = list;
    }

  }
};